const UploadsOptions = {
  meterDataUpload: {
    maxFileSize: (process.env.REACT_APP_METER_DATA_UPLOAD_MAX_FILE_SIZE_MB || 20) * (2 ** 20) //MB
  }
}

export default UploadsOptions